import { SET_EDITOR_DISABLED, SET_EDITOR_INITIALIZED } from "./availableActions";
export var setEditorInitialized = function (payload) { return ({
    type: SET_EDITOR_INITIALIZED,
    payload: payload
}); };
export var setEditorDisabled = function (payload) { return ({
    type: SET_EDITOR_DISABLED,
    payload: payload
}); };
